import { render, staticRenderFns } from "./MenuRowSimple.vue?vue&type=template&id=6d897d0f&"
import script from "./MenuRowSimple.vue?vue&type=script&lang=js&"
export * from "./MenuRowSimple.vue?vue&type=script&lang=js&"
import style0 from "./MenuRowSimple.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports